"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const jsx_runtime_1 = require("react/jsx-runtime");
const formik_1 = require("formik");
const react_1 = require("react");
const ChartContext_1 = require("../../context/ChartContext");
const PreferencesContext_1 = require("../../context/PreferencesContext");
const Scroller_1 = require("../../elements/Scroller");
const useNucleus_1 = __importDefault(require("../../hooks/useNucleus"));
const usePanelPreferences_1 = require("../../hooks/usePanelPreferences");
const convertPathArrayToString_1 = require("../../utility/convertPathArrayToString");
const getSpectraObjectPaths_1 = require("../../utility/getSpectraObjectPaths");
const NucleusGroup_1 = require("../extra/preferences/NucleusGroup");
const PreferencesContainer_1 = require("../extra/preferences/PreferencesContainer");
const SpectraColumnsManager_1 = require("./base/SpectraColumnsManager");
function SpectraPreferences(props, ref) {
    const formRef = (0, react_1.useRef)(null);
    const { data, view: { spectra: { activeTab }, }, } = (0, ChartContext_1.useChartData)();
    const preferences = (0, PreferencesContext_1.usePreferences)();
    const nuclei = (0, useNucleus_1.default)();
    const preferencesByNuclei = (0, usePanelPreferences_1.usePanelPreferencesByNuclei)('spectra', nuclei);
    const { datalist, paths } = (0, react_1.useMemo)(() => (0, getSpectraObjectPaths_1.getSpectraObjectPaths)(data), [data]);
    function saveHandler(values) {
        preferences.dispatch({
            type: 'SET_PANELS_PREFERENCES',
            payload: { key: 'spectra', value: values },
        });
    }
    (0, react_1.useImperativeHandle)(ref, () => ({
        saveSetting: () => {
            formRef.current.submitForm();
        },
    }), []);
    const handleAdd = (0, react_1.useCallback)((nucleus, index) => {
        const data = formRef.current.values;
        let columns = data.nuclei[nucleus]?.columns || [];
        columns = [
            ...columns.slice(0, index),
            {
                jpath: [],
                label: '',
                visible: true,
            },
            ...columns.slice(index),
        ];
        formRef.current.setValues({
            ...data,
            nuclei: {
                ...data.nuclei,
                [nucleus]: {
                    ...data[nucleus],
                    columns,
                },
            },
        });
    }, []);
    const handleDelete = (0, react_1.useCallback)((nucleus, index) => {
        const data = formRef.current.values;
        const columns = data.nuclei[nucleus]?.columns.filter((_, columnIndex) => columnIndex !== index);
        formRef.current.setValues({
            ...data,
            nuclei: {
                ...data.nuclei,
                [nucleus]: {
                    ...data[nucleus],
                    columns,
                },
            },
        });
    }, []);
    const mapOnChangeValueHandler = (0, react_1.useCallback)((key) => paths?.[key] || key, [paths]);
    const mapValue = (0, react_1.useCallback)((value) => (0, convertPathArrayToString_1.convertPathArrayToString)(value), []);
    return ((0, jsx_runtime_1.jsx)(PreferencesContainer_1.PreferencesContainer, { children: (0, jsx_runtime_1.jsx)(formik_1.Formik, { innerRef: formRef, onSubmit: saveHandler, initialValues: preferencesByNuclei, children: (0, jsx_runtime_1.jsx)(Scroller_1.Scroller, { scrollTo: activeTab, children: nuclei?.map((n) => ((0, jsx_runtime_1.jsx)(Scroller_1.Scroller.Item, { elementKey: n, children: (0, jsx_runtime_1.jsx)(NucleusGroup_1.NucleusGroup, { nucleus: n, children: (0, jsx_runtime_1.jsx)(SpectraColumnsManager_1.SpectraColumnsManager, { nucleus: n, onAdd: handleAdd, onDelete: handleDelete, mapOnChangeValue: mapOnChangeValueHandler, mapValue: mapValue, datalist: datalist }) }) }, n))) }) }) }));
}
exports.default = (0, react_1.memo)((0, react_1.forwardRef)(SpectraPreferences));
